import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { format } from 'date-fns';
var ViewBase = /** @class */ (function (_super) {
    tslib_1.__extends(ViewBase, _super);
    function ViewBase() {
        return _super.call(this) || this;
    }
    ViewBase = tslib_1.__decorate([
        Component({
            filters: {
                date: function (value, formatStr) {
                    if (!value) {
                        return '';
                    }
                    if (formatStr.indexOf('yyyy') > -1) {
                        formatStr = formatStr.replace('yyyy', 'YYYY');
                    }
                    return format(value, formatStr);
                }
            }
        })
    ], ViewBase);
    return ViewBase;
}(Vue));
export { ViewBase };
